import { gql, useMutation, useQuery } from "@apollo/client";
import { ODOO_COMPANY_IDS } from "AppSettings";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { Alert } from "components/base/Toast";
import { Fragment } from "react";
import { SYNC_PRODUCT_PRICES_TO_ODOO } from "./graphql";

const FETCH_PRODUCT_PRICES = gql`
  query FETCH_PRODUCT_PRICES($productId: ID!, $productOdooId: Int!) {
    product(id: $productId) {
      id
      activePrices {
        id
        price
        currency
        minQty
        factory {
          id
          nickName
        }
        company
      }
    }
    odooSupplierInfo(productOdooId: $productOdooId)
  }
`;

const SyncPricesToOdooView = ({ productId, productOdooId }) => {
  const { loading, error, data } = useQuery(FETCH_PRODUCT_PRICES, {
    variables: { productId, productOdooId },
    fetchPolicy: "network-only",
  });

  const [syncProductPricesToOdoo, syncProductPricesToOdooRes] = useMutation(
    SYNC_PRODUCT_PRICES_TO_ODOO,
    {
      variables: { id: productId },
      onCompleted: () => Alert("success", "Cost Synced."),
      onError: (error) => Alert("error", error.message),
      refetchQueries: ["FETCH_PRODUCT_PRICES"],
      awaitRefetchQueries: true,
    },
  );

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const odooSupplierInfo = JSON.parse(data.odooSupplierInfo);
  console.log("odooSupplierInfo", odooSupplierInfo);

  console.log("product", data.product);

  const companies = ["AB", "LTD"];

  const wis = {
    AB: data.product.activePrices.filter((i) => i.company === "AB"),
    LTD: data.product.activePrices.filter((i) => i.company === "LTD"),
  };
  const odoo = {
    AB: odooSupplierInfo.filter(
      (info) => info.company_id === ODOO_COMPANY_IDS["AB"],
    ),
    LTD: odooSupplierInfo.filter(
      (info) => info.company_id === ODOO_COMPANY_IDS["LTD"],
    ),
  };

  console.log("wis vs odoo", wis, odoo);

  return (
    <div className="text-sm">
      <table className="with-border">
        <tbody>
          {companies.map((company) => (
            <Fragment key={company}>
              <tr className="bg-gray-200 font-semibold">
                <td>{company}</td>
                <td>Supplier</td>
                <td className="text-right">Min QTY</td>
                <td className="text-right">Price</td>
              </tr>

              {odoo[company].map((price) => (
                <tr key={price.id} className="text-purple-600">
                  <td>
                    <b>Odoo</b>
                  </td>
                  <td>{price.partner_id.display_name}</td>
                  <td className="text-right">{price.min_qty}</td>
                  <td className="text-right">
                    {price.currency_id.display_name} {price.price}
                  </td>
                </tr>
              ))}

              {wis[company].map((price) => (
                <tr key={price.id}>
                  <td>
                    <b>WIS</b>
                  </td>
                  <td>{price.factory.nickName}</td>
                  <td className="text-right">{price.minQty}</td>
                  <td className="text-right">
                    {price.currency} {price.price}
                  </td>
                </tr>
              ))}
            </Fragment>
          ))}
        </tbody>
      </table>

      <div className="mt-6">
        <Button
          primary
          onClick={syncProductPricesToOdoo}
          loading={syncProductPricesToOdooRes.loading}
        >
          Sync to Odoo
        </Button>
      </div>
    </div>
  );
};

export default SyncPricesToOdooView;
